// extracted by mini-css-extract-plugin
export default {"header":"Introduction_header__-VXnP","h1":"Introduction_h1__yGxzc","h2":"Introduction_h2__cNdVH"};